
enum SystemRoleEnum {
    super = 'Super User',
    sysadmin = 'System Admin',
    user = 'Standard User',
}


export default SystemRoleEnum